import React from 'react';
import { isDisplayFormatEnabled } from 'common/helpers/featureFlags';
import ContentItemNew from 'common/charts/types/ContentItem/ContentItemNew';

const ExcelChartTopicPanel = ({ topic, panel, projectId, children }) => {
  const { contentsWithFormatType } = panel;

  const cellRangeContent =
    [302, 301].includes(panel.statusType) && isDisplayFormatEnabled
      ? contentsWithFormatType.find((x) => x.isDisplayedFormatType)
      : undefined;
  return (
    <div data-testid="excel-chart-topic-panel">
      <ContentItemNew
        projectId={projectId}
        libraryItemId={panel.libraryItemId}
        libraryItem={panel}
        contentId={topic.contentThreadId}
        sharedContent={panel.sharedContent}
        content={
          cellRangeContent?.content || panel.sharedContent || panel.content
        }
      >
        {children}
      </ContentItemNew>
    </div>
  );
};
export default ExcelChartTopicPanel;
